import apiClient from "./apiClient";

export const getPermissionsCatalog = async () => {
  const response = await apiClient.get("/api/permissions");
  return response.data?.catalog || response.data?.permissions || response.data?.data || [];
};

export const getRoles = async () => {
  const response = await apiClient.get("/api/roles");
  return response.data?.roles || response.data?.data || response.data || [];
};

export const getRolePermissions = async (roleId) => {
  const response = await apiClient.get(`/api/roles/${roleId}/permissions`);
  return response.data?.permissions || response.data?.data || response.data || [];
};

export const createRole = async (payload) => {
  const response = await apiClient.post("/api/roles", payload);
  return response.data;
};

export const updateRolePermissions = async (roleId, payload) => {
  const response = await apiClient.put(`/api/roles/${roleId}/permissions`, payload);
  return response.data;
};
